import React, {useState, useEffect} from 'react';

import aImage from '../../assets/images/1.1.png';
import bImage from '../../assets/images/2.2.png';
import cImage from '../../assets/images/3.3.png';
import dImage from '../../assets/images/4.4.png';
import eImage from '../../assets/images/5.5.png';
import fImage from '../../assets/images/6.6.png';

function checkValue(value) {
  // if (String(value).length > 0) {
  // return 1;
  // } else if (value > 0) {
  // return value;
  // }
  if (isNaN(value)) {
    return 1;
    } else {
    return value;
    }
  }

  

const InfoBlock = ({ lead }) => {
  // const [disabledBtnConfirm, setDisabledBtnConfirm] = useState(lead.noOfTotalGroups);

  const [soloGroup, setSoloGroup] = useState(0);
//   useEffect(()=>{
//   if (isNaN(lead.noOfTotalGroups)) {
//     setSoloGroup(1); // If it contains alphabets, set soloGroup to 1
//   } else {
//     setSoloGroup(Number(lead.noOfTotalGroups)); // If it's a number, assign its value to soloGroup
//   }
// },[lead])


  
  // function isNumeric(str) {
    
  //   if (typeof str != "string") return false // we only process strings!  
  //   return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  //          !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  // }
  
  // useEffect(()=>{
   
  //   if(!isNumeric(disabledBtnConfirm)) {
  //     setDisabledBtnConfirm(1);
  //   }
    
  // },[lead])

	return (
		<div className='infoBlackSection boxWrapers'>
			<ul className='blockUl'>
        {console.log("The total array returns is ::====>>>>>>>>", lead)}
				{lead.noOfTotalFriends !== 'Not Found' && (
					<li className='totalFriend'>
						<span className='innericon'>
							<img alt='memberimage' src={aImage} className='innerIcons' />
						</span>
						<span className='innetrInfos'>
							<p className='innerHeading'>Total Friends</p>
              	<p className='innerValue'>{checkValue(lead.noOfTotalFriends)}</p>
						</span>
					</li>
				)}
				{lead.noOfMutualFriends !== 'Not Found' && (
					<li className='mutualFriend'>
						<span className='innericon'>
							<img alt='memberimage' src={bImage} className='innerIcons' />
						</span>
						<span className='innetrInfos'>
							<p className='innerHeading'>Mutual Friends</p>
							<p className='innerValue'>{checkValue(lead.noOfMutualFriends)}</p>
						</span>
					</li>
				)}
				{lead.noOfFriendsInGroup !== 'Not Found' && (
					<li className='groupFriend'>
						<span className='innericon'>
							<img alt='memberimage' src={cImage} className='innerIcons' />
						</span>
						<span className='innetrInfos'>
							<p className='innerHeading'>Friends in Group</p>
							<p className='innerValue'>{checkValue(lead.noOfFriendsInGroup)}</p>
						</span>
					</li>
				)}
				{lead.noOfCommonGroups !== 'Not Found' && (
					<li className='commonFriend'>
						<span className='innericon'>
							<img alt='memberimage' src={dImage} className='innerIcons' />
						</span>
						<span className='innetrInfos'>
							<p className='innerHeading'>Common Groups</p>
							<p className='innerValue'>{checkValue(lead.noOfCommonGroups)}</p>
						</span>
					</li>
				)}
				{lead.noOfOtherGroups !== 'Not Found' && (
					<li className='otherFriend'>
						<span className='innericon'>
							<img alt='memberimage' src={eImage} className='innerIcons' />
						</span>
						<span className='innetrInfos'>
							<p className='innerHeading'>Other Groups</p>
							<p className='innerValue'> {checkValue(lead.noOfOtherGroups)}</p>
						</span>
					</li>
				)}
				{lead.noOfTotalGroups !== 'Not Found' && (
					<li className='totalGroup'>
						<span className='innericon'>
							<img alt='memberimage' src={fImage} className='innerIcons' />
						</span>
						<span className='innetrInfos'>
							<p className='innerHeading'>Total Groups</p>
							<p className='innerValue'>{checkValue(lead.noOfTotalGroups)}</p>
              {/* <p className='innerValue'>{soloGroup}</p> */}
						</span>
					</li>
				)}
			</ul>
		</div>
	);
};

export default InfoBlock;
